// ─── src/components/dashboard/MentorStats.tsx ────────────────────────────────
import type { FC } from "react";
import { Users, Globe, MapPin, Clock } from "lucide-react";
import { StatCard }      from "../ui/StatCard";
import { StatsSkeleton } from "../ui/Skeleton";
import type { MentorStatsResponse } from "../../types/stats";

interface Props {
  stats:     MentorStatsResponse;
  isLoading: boolean;
}

export const MentorStats: FC<Props> = ({ stats, isLoading }) => {
  if (isLoading) return <StatsSkeleton />;

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
      <StatCard icon={Users}  label="Total Mentors"     value={stats.total}    accent="bg-brand-teal"       />
      <StatCard icon={Globe}  label="Online Available"  value={stats.online}   accent="bg-indigo-600"       />
      <StatCard icon={MapPin} label="Onsite Available"  value={stats.onsite}   accent="bg-brand-orange/80"  />
      <StatCard icon={Clock}  label="On-demand"         value={stats.onDemand} accent="bg-emerald-600"      />
    </div>
  );
};
